(function (window, document) {
  'use strict';

  function normalize(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function getVariantId() {
    const form = document.querySelector('form[action*="/cart/add"]') || document;

    const checked = form.querySelector('input[name="id"]:checked');
    if (checked?.value) return checked.value;

    const select = form.querySelector('select[name="id"]');
    if (select?.value) return select.value;

    const hidden = form.querySelector('input[name="id"]');
    if (hidden?.value) return hidden.value;

    try {
      return new URL(window.location.href).searchParams.get('variant') || '';
    } catch (error) {
      return '';
    }
  }

  function init(root) {
    if (!root || root.dataset.awReady === 'true') return;
    root.dataset.awReady = 'true';

    const output = root.querySelector('[data-aw-variant-note-output]');
    const dataNode = root.querySelector('[data-aw-variant-note-data]');
    if (!output || !dataNode) return;

    let data = {};
    try {
      data = JSON.parse(dataNode.textContent || '{}');
    } catch (error) {
      console.warn('Unable to parse variant-note data.', error);
      return;
    }

    const optionNames = Array.isArray(data.optionNames) ? data.optionNames : [];

    function optionPosition(names) {
      const normalizedNames = names.map(normalize);
      return optionNames.findIndex((name) => normalizedNames.includes(normalize(name)));
    }

    const contourPosition = optionPosition(['Contour Cut', 'Cutting & Finishing']);
    const ultraPosition = optionPosition(['Ultra Sharp HD Printing', 'Printing Quality']);

    function render() {
      const variant = data.variants?.[String(getVariantId())];
      if (!variant) {
        output.innerHTML = '';
        return;
      }

      const options = Array.isArray(variant.options) ? variant.options : [];
      const contourValue = contourPosition >= 0 ? normalize(options[contourPosition]) : '';
      const ultraValue = ultraPosition >= 0 ? normalize(options[ultraPosition]) : '';

      const hasContour =
        contourValue.includes('yes') ||
        (
          contourValue.includes('contour cut') &&
          !contourValue.includes('no contour cut')
        );

      const hasUltra =
        ultraValue.includes('yes') ||
        ultraValue.includes('ultra sharp hd');

      const blocks = [];

      if (hasContour) {
        blocks.push(`
          <div class="aw-variant-note-item">
            <p>
              Intricate or small contour cut designs, especially in high quantities
              or with dense detail per square foot, may incur extra charges or result in cancellation.
            </p>
            <p>
              We recommend keeping cut files under 10 feet in length to minimize alignment issues.
              Files that exceed this size may require revision or be subject to an additional fee.
            </p>
          </div>
        `);
      }

      if (hasUltra) {
        blocks.push(`
          <div class="aw-variant-note-item">
            <p>
              Learn more about
              <a href="https://alwanwraps.com/pages/new-ultra-sharp-hd-printing">
                Ultra Sharp HD Printing.
              </a>
            </p>
          </div>
        `);
      }

      if (!blocks.length && variant.note) {
        const safe = document.createElement('div');
        safe.textContent = variant.note;
        blocks.push(`<div class="aw-variant-note-item"><i>${safe.innerHTML}</i></div>`);
      }

      output.innerHTML = blocks.join('');
    }

    document.addEventListener('alwan:variant:change', render);
    document.addEventListener('variant:change', () => window.setTimeout(render, 50));
    document.addEventListener('change', (event) => {
      if (event.target.matches('input[name="id"], select[name="id"]')) {
        window.setTimeout(render, 50);
      }
    });

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-aw-variant-notes]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})(window, document);
